var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 2H15.3333C7.96954 2 2 7.96954 2 15.3333V42C2 49.3638 7.96954 55.3333 15.3333 55.3333H42C49.3638 55.3333 55.3333 49.3638 55.3333 42V15.3333C55.3333 7.96954 49.3638 2 42 2Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3337 26.9867C39.6628 29.206 39.2837 31.4726 38.2504 33.4641C37.217 35.4555 35.5821 37.0705 33.578 38.0792C31.574 39.0879 29.3029 39.439 27.0878 39.0825C24.8727 38.7261 22.8264 37.6803 21.2399 36.0938C19.6535 34.5073 18.6076 32.461 18.2512 30.2459C17.8948 28.0308 18.2459 25.7597 19.2546 23.7557C20.2633 21.7516 21.8782 20.1167 23.8697 19.0833C25.8611 18.05 28.1277 17.6709 30.347 18C32.6108 18.3357 34.7066 19.3906 36.3249 21.0088C37.9431 22.6271 38.998 24.7229 39.3337 26.9867Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.333 14H43.3597",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.ff4169f0.svg";
export { ForwardRef as ReactComponent };